<template>
  <div>
    <Toolbar
      :handle-submit="onSendProdFileForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-file-document-edit-outline</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <ProducttypefileForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ProducttypefileForm from '../../components/producttypefile/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Producttypefile';

export default {
  name: 'ProducttypefileUpdate',
  servicePrefix,
  mixins: [UpdateMixin,FileMixin],
  components: {
    Loading,
    Toolbar,
    ProducttypefileForm
  },

  computed: {
    ...mapFields('producttypefile', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('producttypefile', ['find'])

  },

  methods: {
    ...mapActions('producttypefile', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    onSendProdFileForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  }
};
</script>
